module.exports = __webpack_public_path__ + "static/media/lizAnimation2.6cb27b44.gif";